export default "__VITE_ASSET__DMpmu5Z1__"